import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterCustomers from '../components/MasterCustomers';

const MasterCustomersPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterCustomers user={user} />;
};

export default MasterCustomersPage;
